<template>

  <div class="stack_tool_container">
    
    <div class="left">
      <div class="section sketch">
        <div class="header"> 
          <h2>🔥 보장 스케치</h2> 
          <span @click="oth_showCALibrary(true)">더보기 <i class="ph ph-caret-right"></i></span> 
        </div>
        <div class="btns"> 
          <span class="count">솔루션 {{ totalSolutionCount }}개</span>
        </div>
        <ul class="customers" v-if="sketch_list.length > 0">
          <li v-for="(customer, i) in sketch_list" :key="customer.idx" :class="{active: i === 0}" @click="openSolutionEdit(customer)">
            <img :src="customer.thumb" />
            <h3>{{ customer.name }} <small>{{ customer.badge }}</small> </h3>
            <span class="solution-count">솔루션 <b>{{ customer.count }}개</b></span>
            <p class="tag">{{ customer.tag }}</p>
            <button class="link-btn">솔루션 보러가기 <i class="ph ph-caret-right"></i></button>
          </li>
        </ul>
        
        <!-- Empty State: 보장 스케치 -->
        <div class="empty-state sketch-empty" v-else>
          <div class="empty-visual">
            <div class="icon-bg">
              <i class="ph ph-sketch-logo"></i>
            </div>
            <div class="floating-dots">
              <span></span><span></span><span></span>
            </div>
          </div>
          <div class="empty-content">
            <h3>아직 등록된 솔루션이 없어요</h3>
            <p>고객에게 맞는 보장 분석과 솔루션을 만들어보세요</p>
          </div>
          <button class="empty-cta" @click="oth_showCALibrary(true)">
            <i class="ph ph-arrow-right"></i>
            솔루션 만들러 가기
          </button>
        </div>
        
        <div class="indicator" v-if="sketch_list.length > 0">
          <span v-for="(_, i) in Math.min(sketch_list.length, 4)" :key="i" :class="{ active: i === 0 }"></span>
        </div>
      </div>
      
      <div class="section plans">
        <div class="header"> 
          <h2>🔥 추천플랜</h2> 
          <span @click="oth_showPlanShop(true)">더보기 <i class="ph ph-caret-right"></i></span>
        </div>
        <ul class="plan-list" v-if="plan_list.length > 0">
          <li v-for="plan in plan_list" :key="plan.idx" @click="openPlanView(plan)">
            <div class="plan-card-top">
              <img class="plan-logo" :src="plan.image" v-if="plan.image" />
              <div class="plan-logo-placeholder" v-else>
                <i class="ph ph-buildings"></i>
              </div>
              <div class="plan-title-area">
                <span class="plan-company-name">{{ plan.company }}</span>
                <h3>{{ plan.title }}</h3>
              </div>
              <div class="plan-grade" :class="'grade-' + plan.rating">
                {{ plan.rating }}
              </div>
            </div>
            <div class="plan-card-remarks" v-if="plan.remarkTags.length > 0">
              <span 
                v-for="(tag, ti) in plan.remarkTags" :key="ti"
                class="rtag"
                :class="'rtag-' + tag.color"
              >{{ tag.text }}</span>
            </div>
          </li>
        </ul>
        
        <!-- Empty State: 추천 플랜 -->
        <div class="empty-state plan-empty" v-else>
          <div class="empty-visual">
            <div class="icon-bg">
              <i class="ph ph-files"></i>
            </div>
            <div class="stack-cards">
              <span></span><span></span><span></span>
            </div>
          </div>
          <div class="empty-content">
            <h3>공개된 플랜이 없어요</h3>
            <p>다른 설계사들의 추천 플랜을 둘러보세요</p>
          </div>
        </div>
      </div>

    </div>

    <div class="right no-swipe">
      <div class="section request" id="consered" onclick="alert('개발중')">
        <div class="header"> 
          <h2>📝 상품 설계</h2> 
          <span>전체보기 <i class="ph ph-caret-right"></i></span> 
        </div>
        <div class="info-depart"> 
          <div class="stat">
            <span class="label">요청</span>
            <span class="value">2건</span>
          </div>
          <div class="stat">
            <span class="label">완료</span>
            <span class="value">2건</span>
          </div>
        </div>
        <div class="info-banner">
          <div class="descriptions">
            <span>설계자의 키다리든 완벽한 설계가</span>
            <h2><b>2건</b> 있어요!</h2>
          </div>
          <img src="https://amadiary.com/pub/edit_icon/sche_chara_crow01.png" class="bird-icon" />
        </div>
      </div>
      
      <div class="section claim">
        <div class="header"> 
          <h2>💰 최근 청구된 보장</h2> 
          <span @click="oth_showClaimList">전체보기 <i class="ph ph-caret-right"></i></span> 
        </div>
        <div class="info-list">
          <ul v-if="claim_list.length > 0">
            <li v-for="(claim, i) in claim_list" :key="i">
              <span class="customer">{{ claim.customer_name }}</span>
              <span class="company">{{ claim.company_name }}</span>
              <span class="amount">{{ formatMoney(claim.amount) }}원</span>
              <span class="status" :class="'status-' + claim.status">{{ getStatusText(claim.status) }}</span>
              <span class="date">{{ formatDate(claim.request_date) }}</span>
            </li>
          </ul>
          <div class="empty" v-else>
            <p>최근 청구 내역이 없습니다.</p>
          </div>
        </div>
      </div>
      
      <div class="section-btns">
        <button class="btn-primary" @click="oth_showBusinessContact(true)">보험사 정보</button>
        <button class="btn-secondary" @click="oth_showDiseaseSearch(true)">질병코드 조회 <i class="ph ph-magnifying-glass"></i></button>
      </div>
    </div>

  </div>
</template>

<script>
import { inject, ref, computed, onMounted } from "vue";

export default {
  props:{
    oth_showBusinessContact: {
      type: Function,
      required: true,
    },
    oth_showDiseaseSearch: {
      type: Function,
      required: true,
    },
    oth_showClaimList: {
      type: Function,
      required: true,
    },
    oth_showCALibrary: {
      type: Function,
      required: true,
    },
    oth_openSolutionEdit: {
      type: Function,
      required: true,
    },
    oth_openPlanView: {
      type: Function,
      required: true,
    },
    oth_showPlanShop: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const sql_query = inject('sql_query');
    const member_info = inject('member_info');
    const getInsuCompanyInfo = inject('getInsuCompanyInfo');

    const claim_list = ref([]);
    const customers = ref([]);
    const solutions = ref([]);
    const pub_plans = ref([]);


    // 솔루션 총 개수
    const totalSolutionCount = computed(() => solutions.value.length);

    // 고객별 솔루션 매핑 (최근 4명)
    const sketch_list = computed(() => {
      // 솔루션이 있는 고객만 필터링
      const customersWithSolutions = customers.value
        .map(customer => {
          const customerSolutions = solutions.value.filter(s => s.customer_idx === customer.idx);
          if (customerSolutions.length === 0) return null;
          
          // 가장 최근 솔루션 가져오기
          const latestSolution = customerSolutions.sort((a, b) => 
            new Date(b.updated_at) - new Date(a.updated_at)
          )[0];
          
          return {
            idx: customer.idx,
            name: customer.name,
            thumb: customer.image || '/imgs/unknow_user.png',
            count: customerSolutions.length,
            badge: '고객님',
            tag: latestSolution?.name || '솔루션',
            updated_at: latestSolution?.updated_at,
            // 솔루션 편집에 필요한 정보
            latestSolution: latestSolution
          };
        })
        .filter(Boolean)
        .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
        .slice(0, 4);
      
      return customersWithSolutions;
    });

    // ━━━ 담보 기반 태그 생성을 위한 데이터 ━━━
    const chapterListData = ref({});
    const coverageMap = ref({});
    const exCoverageMap = ref(new Map());

    const autoCriteria = [
      { type: 'count',         threshold: 15,    below: 'y:보장항목 적음',   above: 'g:보장항목 많음' },

      { type: 'chapter_max',   match: '암',      threshold: 3000,  below: 'r:암보장 부족',    above: 'g:암보장 좋음' },
      { type: 'chapter_max',   match: '뇌',      threshold: 3000,  below: 'r:뇌보장 부족',    above: 'g:뇌보장 좋음' },
      { type: 'chapter_max',   match: '심장',    threshold: 3000,  below: 'r:심장보장 부족',   above: 'g:심장보장 좋음' },
      { type: 'chapter_max',   match: '수술',    threshold: 500,   below: 'r:수술비 부족',    above: 'g:수술비 좋음' },
      { type: 'chapter_max',   match: '입원',    threshold: 10,    below: 'r:입원비 부족',    above: 'g:입원비 좋음' },
      { type: 'chapter_max',   match: '사망',    threshold: 10000, below: 'y:사망보장 낮음',   above: 'g:사망보장 높음' },
      { type: 'chapter_max',   match: '후유장해', threshold: 10000, below: 'y:후유장해 낮음',   above: 'g:후유장해 높음' },
      { type: 'chapter_max',   match: '진단',    threshold: 2000,  below: 'y:진단금 낮음',    above: 'g:진단금 좋음' },

      { type: 'chapter_count', match: '실손',    threshold: 1,     below: 'r:실손 미가입',    above: 'b:실손 가입' },

      { type: 'total_avg',     threshold: 1500,  below: 'y:평균 보장금 낮음', above: 'g:평균 보장금 높음' },

      { type: 'price',         threshold: 80000, below: null,               above: 'y:높은 보험료' },
      { type: 'price',         threshold: 30000, below: 'g:저렴한 보험료',   above: null },

      { type: 'rate',          threshold: 85,    below: null,               above: 'g:높은 평점' },
      { type: 'rate',          threshold: 60,    below: 'r:낮은 평점',      above: null },

      { type: 'renewable',     eq: 0, tag: 'g:비갱신형' },
      { type: 'renewable',     eq: 1, tag: 'y:갱신형' },
    ];

    function getCoveragesByKeyword(covList, keyword) {
      const matchedIdxs = [];
      for (const root of Object.values(chapterListData.value)) {
        if (root.name.includes(keyword)) {
          Object.values(root.list).forEach(child => matchedIdxs.push(child.idx));
        }
        for (const child of Object.values(root.list)) {
          if (child.name.includes(keyword)) matchedIdxs.push(child.idx);
        }
      }
      return covList.filter(c => matchedIdxs.includes(c.chapter_idx));
    }

    function generateAutoRemarks(planRaw) {
      const tags = [];
      const planId = planRaw.wr_id || planRaw.idx;
      const covList = (coverageMap.value[planId] || []).filter(c => !c.is_union && !c.low_show);
      const values = covList.map(c => Number(c.value) || 0);

      for (const rule of autoCriteria) {
        if (rule.eq !== undefined) {
          if (String(planRaw[rule.type]) === String(rule.eq)) tags.push(...parseRemarks(rule.tag));
          continue;
        }
        let val = null;
        switch (rule.type) {
          case 'count': val = covList.length; break;
          case 'chapter_count': val = getCoveragesByKeyword(covList, rule.match).length; break;
          case 'chapter_max': {
            const m = getCoveragesByKeyword(covList, rule.match);
            if (m.length === 0) continue;
            val = Math.max(...m.map(c => Number(c.value) || 0)); break;
          }
          case 'chapter_sum': {
            const m = getCoveragesByKeyword(covList, rule.match);
            if (m.length === 0) continue;
            val = m.reduce((s, c) => s + (Number(c.value) || 0), 0); break;
          }
          case 'total_max':
            if (values.length === 0) continue;
            val = Math.max(...values); break;
          case 'total_avg':
            if (values.length === 0) continue;
            val = values.reduce((a, b) => a + b, 0) / values.length; break;
          case 'price': val = Number(planRaw.price) || null; break;
          case 'rate': val = Number(planRaw.rate) || null; break;
          default: continue;
        }
        if (val === null) continue;
        if (val < rule.threshold && rule.below) tags.push(...parseRemarks(rule.below));
        else if (val >= rule.threshold && rule.above) tags.push(...parseRemarks(rule.above));
      }
      return tags;
    }

    /**
     * remarks 파싱
     * DB 저장 포맷: "g:유병자 O|r:높은 가격|b:무해지|일반 텍스트"
     * g: = green (장점), r: = red (단점), b: = blue (정보), y: = yellow (주의), 접두사 없으면 default
     */
    function parseRemarks(remarks) {
      if (!remarks || !remarks.trim()) return [];
      const colorMap = { 'g': 'green', 'r': 'red', 'b': 'blue', 'y': 'yellow' };
      return remarks.split('|').map(item => {
        const trimmed = item.trim();
        if (!trimmed) return null;
        const match = trimmed.match(/^([grby]):(.+)$/);
        if (match) {
          return { color: colorMap[match[1]], text: match[2].trim() };
        }
        return { color: 'default', text: trimmed };
      }).filter(Boolean);
    }

    // 추천 플랜 (공개된 플랜)
    const plan_list = computed(() => {
      return pub_plans.value.slice(0, 3).map((plan) => {
        const companyInfo = getInsuCompanyInfo ? getInsuCompanyInfo(plan.company) : null;
        const rate = plan.rate || 60;
        let rating = 'B';
        if (rate >= 90) rating = 'S+';
        else if (rate >= 80) rating = 'A+';
        else if (rate >= 70) rating = 'A';
        else if (rate >= 60) rating = 'B';
        else rating = 'C';
        
        const parsed = parseRemarks(plan.remarks);
        return {
          idx: plan.wr_id,
          title: plan.name,
          company: companyInfo?.name || plan.company || '보험사',
          image: companyInfo?.short_img || '',
          price: formatMoney(plan.price) + '원',
          rating: rating,
          rating_percent: (plan.rate || 60) + '%',
          downloads: Math.floor(Math.random() * 50) + 10,
          remarkTags: parsed.length > 0 ? parsed : generateAutoRemarks(plan),
          category: plan.category || 'all',
          raw: plan
        };
      });
    });


    // 고객 목록 조회
    async function fetchCustomers() {
      const sql = `SELECT * FROM customers WHERE mb_id = '${member_info.mb_id}' ORDER BY last_touch DESC`;
      const result = await sql_query(sql);
      customers.value = result || [];
    }

    // 솔루션 목록 조회
    async function fetchSolutions() {
      const sql = `SELECT * FROM IS_solution WHERE mb_id = '${member_info.mb_id}' ORDER BY updated_at DESC`;
      const result = await sql_query(sql);
      solutions.value = result || [];
    }

    // 챕터 트리 로드
    async function fetchChapters() {
      const roots = await sql_query(`SELECT * FROM IS_chapter WHERE (parent IS NULL OR parent = 0) AND status = 1 ORDER BY no ASC`);
      const children = await sql_query(`SELECT * FROM IS_chapter WHERE parent IS NOT NULL AND parent != 0 AND status = 1 ORDER BY no ASC`);
      const tree = {};
      for (const ch of roots) {
        tree[ch.en_name] = { idx: ch.idx, no: ch.no, name: ch.name, list: {} };
      }
      for (const ch of children) {
        const parent = roots.find(r => r.idx === ch.parent);
        if (parent && tree[parent.en_name]) {
          tree[parent.en_name].list[ch.en_name] = { name: ch.name, idx: ch.idx, no: ch.no };
        }
      }
      chapterListData.value = tree;
    }

    // 담보 배치 로드
    async function fetchBatchCoverages(planIds) {
      if (planIds.length === 0) return;
      if (exCoverageMap.value.size === 0) {
        const originals = await sql_query(`SELECT * FROM IS_ex_coverage`);
        exCoverageMap.value = new Map((originals || []).map(o => [o.idx, o]));
      }
      const ids = planIds.join(',');
      const rows = await sql_query(`SELECT * FROM IS_coverage WHERE plan_id IN (${ids}) AND visible = 1 ORDER BY idx DESC`);
      const map = {};
      for (const cov of (rows || [])) {
        const orig = exCoverageMap.value.get(cov.original);
        const item = {
          idx: cov.idx,
          chapter_idx: cov.chapter_id || orig?.chapter_id,
          value: cov.value,
          is_union: cov.is_union || 0,
          low_show: cov.low_show || 0,
        };
        if (!map[cov.plan_id]) map[cov.plan_id] = [];
        map[cov.plan_id].push(item);
      }
      coverageMap.value = map;
    }

    // 공개 플랜 조회
    async function fetchPubPlans() {
      // 챕터 먼저
      await fetchChapters();

      const sql = `SELECT * FROM IS_plan WHERE public = '1' ORDER BY idx DESC LIMIT 10`;
      const result = await sql_query(sql);
      pub_plans.value = (result || []).map(row => ({
        wr_id: row.idx,
        mb_id: row.mb_id,
        name: row.name,
        company: row.company,
        price: row.price,
        rate: row.rate || 60,
        remarks: row.remarks || '',
        renewable: row.renewable,
        type: row.type || '',
        worth: row.worth || 0,
        created_at: row.created_at,
      }));

      // 담보 배치 로드
      const planIds = pub_plans.value.map(p => p.wr_id);
      await fetchBatchCoverages(planIds);
    }

    // 최근 청구 목록 조회 (최근 10건)
    async function fetchClaims() {
      let sql = `
        SELECT 
          ic.*,
          c.name as customer_name,
          comp.name as company_name
        FROM insu_claims ic
        LEFT JOIN customers c ON ic.customer_idx = c.idx
        LEFT JOIN insu_company comp ON ic.insu_company_idx = comp.idx
        WHERE c.mb_id = '${member_info.mb_id}'
        ORDER BY ic.request_date DESC
        LIMIT 10
      `;
      let result = await sql_query(sql);
      claim_list.value = result || [];
    }

    function formatMoney(val) {
      if (!val) return '0';
      return Number(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      const yy = String(d.getFullYear()).slice(2);
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yy}.${mm}.${dd}`;
    }

    function getStatusText(status) {
      const statusMap = {
        0: '접수',
        1: '심사중',
        2: '승인',
        3: '지급완료',
        4: '반려'
      };
      return statusMap[status] || '-';
    }

    // 솔루션 편집 열기
    function openSolutionEdit(customer) {
      if (customer.latestSolution) {
        props.oth_openSolutionEdit(customer.latestSolution);
      }
    }

    // 플랜 뷰 열기
    function openPlanView(plan) {
      props.oth_openPlanView(plan.idx);
    }

    onMounted(() => {
      fetchCustomers();
      fetchSolutions();
      fetchPubPlans();
      fetchClaims();
    });

    return {
      sketch_list,
      plan_list,
      claim_list,
      totalSolutionCount,
      formatMoney,
      formatDate,
      getStatusText,
      openSolutionEdit,
      openPlanView,
    };
  }
}
</script>

<style scoped>

#consered {
  opacity: 0.6;
  filter: blur(1px);
}

.stack_tool_container {
  width: 100%;
  height: 100%;
  display: flex;
  gap: 24px;
  box-sizing: border-box;
}

.left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
  height: 100%;
  color:#fff;
}

.right {
  width: 410px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  overflow-y: auto;
  color:#fff;
}

.right::-webkit-scrollbar {
  width: 4px;
}

.right::-webkit-scrollbar-thumb {
  background: var(--color-text-secondary);
  border-radius: 2px;
}

.section {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.right .section {
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(var(--blur));
  border-radius: var(--radius-lg);
  padding: 18px;
  box-sizing: border-box;
}

.section.sketch {
  flex: 2;
  min-height: 0;
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(var(--blur));
  border-radius: var(--radius-lg);
  padding: 18px;
  box-sizing: border-box;
}

.section.plans {
  flex: 1;
  min-height: 0;
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(var(--blur));
  border-radius: var(--radius-lg);
  padding: 18px;
  box-sizing: border-box;
}

.section.request {
  min-height: 130px;
  flex:1;
}

.section.claim {
  flex: 1;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-shrink: 0;
}

.header h2 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  margin: 0;
  color: #fff;
}

.header span {
  font-size: var(--font-size-base);
  color: #fff;
  opacity:0.6;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

.header span:hover {
  opacity: 1;
}

.btns {
  display: flex;
  justify-content: end;
  gap:12px;
  align-items: center;
  margin-bottom: 24px;
  flex-shrink: 0;
}

.count {
  background: var(--color-surface);
  color: #fff;
  border: none;
  border-radius: var(--radius-md);
  padding: 6px 12px;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
}

.customers {
  list-style: none;
  padding: 0;
  margin: 0 0 24px 0;
  display: flex;
  gap: 10px;
  overflow-x: auto;
  flex-shrink: 0;
}

.customers::-webkit-scrollbar {
  height: 3px;
}

.customers::-webkit-scrollbar-thumb {
  background: var(--color-text-secondary);
  border-radius: var(--radius-sm);
}

.customers li {
  min-width: 200px;
  max-width: 200px;
  background: var(--color-surface-reverse);
  border: 2px solid var(--color-surface);
  border-radius: var(--radius-lg);
  padding: 12px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.customers li:hover {
  border-color: var(--color-brand);
}

.customers li.active {
  border-color: var(--color-brand);
}

.customers li img {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  object-fit: cover;
  margin-bottom: 4px;
}

.customers li h3 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  margin: 0;
  color: #fff;
  display:flex;
  align-items: center;
  justify-content: start;
  gap:12px;
}

.customers li h3 small {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--color-text-secondary);
}

.customers li .solution-count {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.customers li .solution-count b {
  color: var(--color-brand);
  font-weight: var(--font-weight-bold);
}

.customers li .tag {
  font-size: var(--font-size-xs);
  background: var(--color-surface);
  color: #fff;
  padding: 4px 8px;
  border-radius: var(--radius-md);
  margin: 0;
  width: fit-content;
}

.customers li .link-btn {
  width: 100%;
  height: 32px;
  background: var(--color-brand);
  color: var(--color-text-black);
  border: none;
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: auto;
}

/* ===== Empty State 공통 스타일 ===== */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  flex: 1;
  min-height: 180px;
}

.empty-state .empty-visual {
  position: relative;
  margin-bottom: 20px;
}

.empty-state .icon-bg {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--color-surface) 0%, var(--color-surface-deep) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.empty-state .icon-bg i {
  font-size: 36px;
  color: var(--color-text-secondary);
  opacity: 0.7;
}

/* 보장 스케치 empty - 떠다니는 점들 */
.sketch-empty .floating-dots {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
}

.sketch-empty .floating-dots span {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-brand);
  opacity: 0.3;
  animation: float 3s ease-in-out infinite;
}

.sketch-empty .floating-dots span:nth-child(1) {
  top: 0;
  left: 50%;
  animation-delay: 0s;
}

.sketch-empty .floating-dots span:nth-child(2) {
  bottom: 10px;
  left: 10px;
  animation-delay: 0.5s;
}

.sketch-empty .floating-dots span:nth-child(3) {
  bottom: 10px;
  right: 10px;
  animation-delay: 1s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-8px) scale(1.2);
    opacity: 0.6;
  }
}

/* 추천 플랜 empty - 쌓인 카드들 */
.plan-empty .stack-cards {
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
}

.plan-empty .stack-cards span {
  position: absolute;
  width: 50px;
  height: 6px;
  border-radius: 3px;
  background: var(--color-surface);
  left: 50%;
  transform: translateX(-50%);
}

.plan-empty .stack-cards span:nth-child(1) {
  bottom: 0;
  width: 50px;
  opacity: 0.4;
}

.plan-empty .stack-cards span:nth-child(2) {
  bottom: -6px;
  width: 40px;
  opacity: 0.25;
}

.plan-empty .stack-cards span:nth-child(3) {
  bottom: -12px;
  width: 30px;
  opacity: 0.15;
}

.empty-state .empty-content {
  text-align: center;
  margin-bottom: 20px;
}

.empty-state .empty-content h3 {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: #fff;
  margin: 0 0 8px 0;
}

.empty-state .empty-content p {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.5;
}

.empty-state .empty-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.empty-state .empty-cta:not(.secondary) {
  background: var(--color-brand);
  color: var(--color-text-black);
}

.empty-state .empty-cta:not(.secondary):hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(247, 109, 40, 0.3);
}

.empty-state .empty-cta.secondary {
  background: var(--color-surface);
  color: #fff;
  border: 1px solid var(--color-surface);
}

.empty-state .empty-cta.secondary:hover {
  background: rgba(0,0,0,0.4);
  border-color: var(--color-brand);
}

.empty-state .empty-cta i {
  font-size: var(--font-size-md);
}

/* ===== 기존 indicator 스타일 ===== */
.indicator {
  display: flex;
  justify-content: end;
  gap: 6px;
  flex-shrink: 0;
}

.indicator span {
  width: 16px;
  height: 16px;
  border-radius: 100px;
  background: var(--color-background-reverse);
  opacity: 0.4;
}

.indicator span.active {
  background: #fff;
  width: 48px;
  opacity: 1;
}

/* ===== Plan List 카드 스타일 (스크린샷 기반) ===== */
.plan-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  flex-shrink: 0;
}

.plan-list > li {
  flex: 1 1 0;
  min-width: 200px;
  background: light-dark(#ffffff, #1a1a1f);
  border-radius: var(--radius-lg);
  padding: 14px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  transition: all 0.25s ease;
  border: 1.5px solid light-dark(#eaeaea, #2a2a30);
}

.plan-list > li:hover {
  border-color: var(--color-brand);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px light-dark(rgba(0,0,0,0.1), rgba(0,0,0,0.4));
}

/* 카드 상단: 로고 + 제목 + 등급 */
.plan-card-top {
  display: flex;
  align-items: center;
  gap: 10px;
}

.plan-logo {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  object-fit: contain;
  flex-shrink: 0;
  background: light-dark(#f8f8f8, #252528);
}

.plan-logo-placeholder {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: light-dark(#f0f0f0, #252528);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.plan-logo-placeholder i {
  font-size: var(--font-size-lg);
  color: var(--color-text-secondary);
}

.plan-title-area {
  flex: 1;
  min-width: 0;
}

.plan-title-area .plan-company-name {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  display: block;
  margin-bottom: 2px;
}

.plan-title-area h3 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-extrabold);
  margin: 0;
  color: light-dark(#111, #f0f0f0);
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 등급 배지 - 아이콘 스타일 */
.plan-grade {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-black);
  flex-shrink: 0;
  line-height: 1;
  letter-spacing: -0.5px;
}

.plan-grade.grade-S\+ { background: rgba(91,123,240,0.12); color: #5B7BF0; }
.plan-grade.grade-A\+ { background: rgba(76,175,80,0.12); color: #4CAF50; }
.plan-grade.grade-A { background: rgba(102,187,106,0.12); color: #66BB6A; }
.plan-grade.grade-B { background: rgba(255,152,0,0.12); color: #FF9800; }
.plan-grade.grade-C { background: rgba(244,67,54,0.12); color: #F44336; }

/* 카드 하단: Remark Tags */
.plan-card-remarks {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding-top: 10px;
  border-top: 1px solid light-dark(#f0f0f0, #2a2a30);
}

.rtag {
  display: inline-block;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  padding: 2px 9px;
  border-radius: 100px;
  line-height: 1.7;
  white-space: nowrap;
}

.rtag-green {
  background: rgba(34, 197, 94, 0.12);
  color: #22C55E;
}

.rtag-red {
  background: rgba(239, 68, 68, 0.12);
  color: #EF4444;
}

.rtag-blue {
  background: rgba(59, 130, 246, 0.12);
  color: #3B82F6;
}

.rtag-yellow {
  background: rgba(245, 158, 11, 0.12);
  color: #F59E0B;
}

.rtag-default {
  background: light-dark(rgba(0,0,0,0.05), rgba(255,255,255,0.08));
  color: light-dark(#555, #aaa);
}


/* ===== Right Section 스타일 ===== */
.info-depart {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}

.info-depart .stat {
  flex: 1;
  background: var(--color-surface);
  border-radius: var(--radius-md);
  padding: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.info-depart .stat .label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.info-depart .stat .value {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: #fff;
}

.info-banner {
  background: linear-gradient(135deg, var(--color-surface) 0%, var(--color-surface-deep) 100%);
  border-radius: var(--radius-lg);
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.descriptions {
  display: flex;
  flex-direction: column;
}

.descriptions span {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  margin-bottom: 6px;
}

.descriptions h2 {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  margin: 0;
  color: #fff;
}

.descriptions h2 b {
  color: var(--color-brand);
}

.bird-icon {
  width: 55px;
  height: 55px;
  object-fit: contain;
}

.info-list {
  flex: 1;
  overflow-y: auto;
}

.info-list::-webkit-scrollbar {
  width: 3px;
}

.info-list::-webkit-scrollbar-thumb {
  background: var(--color-text-secondary);
  border-radius: 2px;
}

.info-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.info-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 0;
  border-bottom: 1px solid var(--color-surface);
  gap: 8px;
}

.info-list li .customer {
  font-size: var(--font-size-sm);
  color: #fff;
  font-weight: var(--font-weight-semibold);
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-list li .company {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  flex: 1;
}

.info-list li .amount {
  font-size: var(--font-size-base);
  color: var(--color-brand);
  font-weight: var(--font-weight-bold);
  flex: 1;
  text-align: center;
}

.info-list li .status {
  font-size: var(--font-size-xs);
  padding: 2px 8px;
  border-radius: 10px;
  color: #fff;
}

.info-list li .status.status-0 { background: #9e9e9e; }
.info-list li .status.status-1 { background: #ff9800; }
.info-list li .status.status-2 { background: #2196f3; }
.info-list li .status.status-3 { background: #4caf50; }
.info-list li .status.status-4 { background: #f44336; }

.info-list li .date {
  font-size: 10px;
  color: var(--color-text-secondary);
  min-width: 50px;
  text-align: right;
}

.info-list .empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;
}

.info-list .empty p {
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
  margin: 0;
}

.section-btns {
  display: flex;
  height: 90px;
  gap: 10px;
}

.section-btns button {
  flex: 1;
  height: 100%;
  border: none;
  border-radius: var(--radius-lg);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.btn-primary {
  background: #F76D28;
  color: var(--color-text-black);
}

.btn-secondary {
  background: rgba(0,0,0,1);
  color: #fff;
  border: 1px solid var(--color-surface);
}

.btn-secondary i {
  font-size: var(--font-size-xl);
}

/* ===== 태블릿/작은 화면 반응형 ===== */
@media (max-width: 1024px), (max-height: 768px) {
  .stack_tool_container {
    gap: 12px;
  }

  .left {
    gap: 12px;
  }

  .right {
    width: 280px;
    gap: 10px;
  }

  .right .section {
    padding: 12px;
  }

  .section.sketch,
  .section.plans {
    padding: 12px;
  }

  .header {
    margin-bottom: 10px;
  }

  .header h2 {
    font-size: var(--font-size-md);
  }

  .header span {
    font-size: var(--font-size-sm);
  }

  .btns {
    margin-bottom: 12px;
    gap: 8px;
  }

  .count {
    padding: 4px 10px;
    font-size: var(--font-size-sm);
  }

  .customers {
    margin-bottom: 12px;
    gap: 8px;
  }

  .customers li {
    min-width: 140px;
    max-width: 140px;
    padding: 10px;
    gap: 6px;
  }

  .customers li img {
    width: 40px;
    height: 40px;
    border-radius: 8px;
  }

  .customers li h3 {
    font-size: var(--font-size-base);
    gap: 6px;
  }

  .customers li h3 small {
    font-size: var(--font-size-xs);
  }

  .customers li .solution-count {
    font-size: var(--font-size-xs);
  }

  .customers li .tag {
    font-size: 9px;
    padding: 2px 5px;
  }

  .customers li .link-btn {
    height: 26px;
    font-size: 11px;
  }

  .indicator span {
    width: 10px;
    height: 10px;
  }

  .indicator span.active {
    width: 30px;
  }

  .plan-list {
    gap: 8px;
  }

  .plan-list > li {
    min-width: 180px;
    padding: 12px;
    gap: 10px;
  }

  .plan-logo, .plan-logo-placeholder {
    width: 40px;
    height: 40px;
    border-radius: 8px;
  }

  .plan-title-area h3 {
    font-size: var(--font-size-base);
  }

  .plan-grade {
    width: 34px;
    height: 34px;
    font-size: var(--font-size-sm);
  }

  .plan-card-remarks {
    gap: 4px;
    padding-top: 8px;
  }

  /* Empty State 반응형 */
  .empty-state {
    padding: 20px 16px;
    min-height: 140px;
  }

  .empty-state .icon-bg {
    width: 60px;
    height: 60px;
  }

  .empty-state .icon-bg i {
    font-size: 28px;
  }

  .empty-state .empty-visual {
    margin-bottom: 16px;
  }

  .empty-state .empty-content h3 {
    font-size: var(--font-size-sm);
  }

  .empty-state .empty-content p {
    font-size: var(--font-size-xs);
  }

  .empty-state .empty-content {
    margin-bottom: 16px;
  }

  .empty-state .empty-cta {
    padding: 10px 20px;
    font-size: var(--font-size-xs);
  }

  .sketch-empty .floating-dots {
    width: 90px;
    height: 90px;
  }

  .sketch-empty .floating-dots span {
    width: 6px;
    height: 6px;
  }

  /* Right 영역 */
  .section.request {
    min-height: 100px;
  }

  .info-depart {
    gap: 8px;
    margin-bottom: 10px;
  }

  .info-depart .stat {
    gap: 6px;
    padding: 4px;
    border-radius: 8px;
  }

  .info-depart .stat .label {
    font-size: var(--font-size-xs);
  }

  .info-depart .stat .value {
    font-size: var(--font-size-base);
  }

  .info-banner {
    gap: 12px;
    padding: 8px;
    border-radius: 8px;
  }

  .descriptions span {
    font-size: var(--font-size-xs);
    margin-bottom: 4px;
  }

  .descriptions h2 {
    font-size: var(--font-size-lg);
  }

  .bird-icon {
    width: 45px;
    height: 45px;
  }

  .info-list li {
    padding: 6px 0;
    gap: 4px;
  }

  .info-list li .customer {
    font-size: var(--font-size-xs);
  }

  .info-list li .company {
    font-size: 10px;
  }

  .info-list li .amount {
    font-size: var(--font-size-sm);
  }

  .info-list li .status {
    font-size: 10px;
    padding: 2px 6px;
  }

  .info-list li .date {
    font-size: 9px;
  }

  .info-list .empty p {
    font-size: var(--font-size-xs);
  }

  .section-btns {
    height: 60px;
    gap: 8px;
  }

  .section-btns button {
    font-size: var(--font-size-base);
    gap: 8px;
    border-radius: var(--radius-md);
  }

  .btn-secondary i {
    font-size: var(--font-size-lg);
  }
}

/* #### Portrait 모드 (태블릿/모바일 세로) #### */
@media (max-width: 1024px) and (orientation: portrait) {
  .stack_tool_container {
    flex-direction: column;
    gap: 12px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .left {
    flex: none;
    height: auto;
    gap: 12px;
  }

  .right {
    width: 100% !important;
    height: auto;
    flex: none;
    gap: 10px;
    overflow-y: visible;
  }

  .section.sketch { flex: none; min-height: 200px; }
  .section.plans { flex: none; min-height: 160px; }
  .section.request { flex: none; min-height: 100px; }
  .section.claim { flex: none; min-height: 120px; }
  .section-btns { height: 50px; }
}
</style>